module.exports = __webpack_public_path__ + "static/media/logo.2159b92d.png";